
/**
 *
 * 判断false
 * @export
 * @param {Object} option:
 * @returns
 */
export function isNull(_name) {
  if (_name === '' || _name === undefined || _name === null) return true
  return false
}

/**
 *
 * select过滤
 * @export
 * @param {Object} option:
 * @params val 选中值
 * @params list{Array} 数组
 * @params key{string} 键名
 * @returns 选中的对象
 */
export function filterParams(val, list, key) {
  if (!isNull(val) && !isNull(list) && !isNull(key)) {
    return list.find(cur => cur[key] === val)
  }
  return ''
}
// api参数过滤空的undefined null的
export function removeEmptyField(params = {}, removeField = []) {
  const copyParams = JSON.parse(JSON.stringify(params))
  let arrField = removeField
  if (removeField.length === 0) {
    arrField = Object.keys(params)
  }
  arrField.forEach(key => {
    const val = copyParams[key]
    if (val === '' || val === undefined || val === null) {
      delete copyParams[key]
    }
  })
  return copyParams
}

export function ObjectAssignSingle(obj1, obj2) {
  if (typeof obj1 !== 'object' || obj1 === null || obj2 === null) {
    return obj2
  } else if (obj1 instanceof Array && obj2 instanceof Array) {
    return obj2
  } else {
    const obj1Key = Object.keys(obj1)
    const obj2Key = Object.keys(obj2)
    obj1Key.forEach(key1 => {
      obj2Key.forEach(key2 => {
        if (key1 === key2) {
          if (typeof obj1[key1] !== 'object' || obj1[key1] === null) {
            obj1[key1] = obj2[key2]
          } else if (obj1 instanceof Array && obj2 instanceof Array) {
            obj1[key1] = obj2[key2]
          } else {
            ObjectAssignSingle(obj1[key1], obj2[key2])
          }
        }
      })
    })
  }
}

export function betchToString(obj, fn) {
  if (typeof obj !== 'object' || obj === null || obj instanceof Array) {
    return obj
  }
  Object.keys(obj).forEach(val => {
    if (fn(val)) {
      obj[val] = isNull(obj[val]) ? '' : JSON.stringify(obj[val])
    }
  })
}

export function formatByte(val) {
  if (isNaN(val)) return ''
  var list = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  var temp = Math.floor(Math.log(val) / Math.log(2))
  if (temp < 1) temp = 0
  var num = Math.floor(temp / 10)
  val = val / Math.pow(2, 10 * num)
  if (val.toString().length > val.toFixed(2).toString().length) val = val.toFixed(2)
  return val + ' ' + list[num]
}

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return time_str
}
